import {GetCommunications} from 'domain/usecases/private/communications/get-communications';
import {mapCommunicationsData} from '../../utils/mapCommunicationsData';
import {GetCommunicationsService} from './types';

function getCommunications(makeGetCommunications: GetCommunications): GetCommunicationsService {
	return {
		perform: async ({isEnabled, signal}) => {
			if (!isEnabled) {
				return [];
			}
			const response = await makeGetCommunications.get({signal});
			return Array.isArray(response) ? mapCommunicationsData(response) : [];
		},
	};
}

export {getCommunications};
